<div class="modal">
  <div class="help-page">
    <button class="close-btn" (click)="closeHelpDialog()">X</button>
    <h2>{{ 'ACHIEVEMENTS.help.title' | translate }}</h2>
    <p>
      {{ 'ACHIEVEMENTS.help.description' | translate }}
    </p>
    <ul>
      <li>{{ 'ACHIEVEMENTS.help.levelExplanation' | translate }}</li>
      <ul class="achievement-icons">
        <li>
          <div class="achievement-card">
            <p>{{ 'ACHIEVEMENTS.levelNames.unlocked' | translate }}</p>
            <div class="achievement-icon">
              <app-achivement-progress [progress]="0" [color]="'#929292'" [name]="'Sehkraft'"></app-achivement-progress>
              <img src="assets/icons/achivement/unlocked/sehkraft.svg" alt="{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}" />
              <span [style.color]="'#929292'" class="progress-text">0/3</span>
            </div>
            <div class="achievement-name">{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}</div>
          </div>
        </li>
        <li>
          <div class="achievement-card">
            <p>{{ 'ACHIEVEMENTS.levelNames.green' | translate }}</p>
            <div class="achievement-icon">
              <app-achivement-progress
                [progress]="20"
                [color]="'#1F8D16'"
                [name]="'Sehkraft'"
              ></app-achivement-progress>
              <img src="assets/icons/achivement/green/sehkraft.svg" alt="{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}" />
              <span [style.color]="'#1F8D16'" class="progress-text">4/20</span>
            </div>
            <div class="achievement-name">{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}</div>
          </div>
        </li>
        <li>
          <div class="achievement-card">
            <p>{{ 'ACHIEVEMENTS.levelNames.bronze' | translate }}</p>
            <div class="achievement-icon">
              <app-achivement-progress [progress]="5" [color]="'#8F551B'" [name]="'Sehkraft'"></app-achivement-progress>
              <img src="assets/icons/achivement/bronze/sehkraft.svg" alt="{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}" />
              <span [style.color]="'#8F551B'" class="progress-text">3/60</span>
            </div>
            <div class="achievement-name">{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}</div>
          </div>
        </li>
        <li>
          <div class="achievement-card">
            <p>{{ 'ACHIEVEMENTS.levelNames.silber' | translate }}</p>
            <div class="achievement-icon">
              <app-achivement-progress [progress]="0" [color]="'#646464'" [name]="'Sehkraft'"></app-achivement-progress>
              <img src="assets/icons/achivement/silber/sehkraft.svg" alt="{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}" />
              <span [style.color]="'#646464'" class="progress-text">0/180</span>
            </div>
            <div class="achievement-name">{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}</div>
          </div>
        </li>
        <li>
          <div class="achievement-card">
            <p>{{ 'ACHIEVEMENTS.levelNames.gold' | translate }}</p>
            <div class="achievement-icon">
              <img src="assets/icons/achivement/gold/sehkraft.svg" alt="{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}" />
            </div>
            <div class="achievement-name">{{ 'ACHIEVEMENTS.achievementNames.Sehkraft' | translate }}</div>
          </div>
        </li>
      </ul>
      <p>{{ 'ACHIEVEMENTS.help.example' | translate }}</p>
      <p>
        {{ 'ACHIEVEMENTS.help.exampleText' | translate }}
      </p>
      <p>
        {{ 'ACHIEVEMENTS.help.progressExplanation' | translate }}
      </p>
      <p>{{ 'ACHIEVEMENTS.help.levelDifficulty' | translate }}</p>
      <p>{{ 'ACHIEVEMENTS.help.dailyLimit' | translate }}</p>
      <p>
        {{ 'ACHIEVEMENTS.help.hiddenAchievements' | translate }}
      </p>
      <p>
        {{ 'ACHIEVEMENTS.help.pointsExplanation' | translate }}
      </p>
      <p>{{ 'ACHIEVEMENTS.help.exercisePoints' | translate }}</p>
      <p>
        {{ 'ACHIEVEMENTS.help.monthlyPoints' | translate }}
      </p>
    </ul>
  </div>
</div>


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/achievement/components/help-dialog/help-dialog.component.html